import { styled } from '@mui/material';
import { Box } from '@mui/material';

export const DotSeparator = styled((props: any) => (
    <Box {...props}>•</Box>
))((props: any) => ({
    padding: '0 4px',
}));